/* import __COLOCATED_TEMPLATE__ from './rule-editor-actions-section.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();